import { Controller } from "@hotwired/stimulus"
import { loadStripe } from "@stripe/stripe-js";

export default class extends Controller {

  static targets = [ "form" ]

  static values = {
    publishableKey: String,
    locale: String,
    clientSecret: String,
    returnUrl: String,
    currency: String,
    label: String,
    amount: Number,
    countryCode: String
  }

  connect() {
    this.initStripe().then(() => {
      this.makePaymentRequest();
      this.processPaymentRequest();
    });
  }

  async initStripe() {
    this.stripe = await loadStripe(this.publishableKeyValue, { locale: this.localeValue });
  }

  makePaymentRequest() {
    const stripe = this.stripe;
    const clientSecretValue = this.clientSecretValue;
    const returnUrl = this.returnUrlValue;
    const form = this.formTarget;

    this.paymentRequest = this.stripe.paymentRequest({
      country: this.countryCodeValue,
      currency: this.currencyValue,
      total: {
        label: this.labelValue,
        amount: this.amountValue
      },
      requestPayerName: true,
      requestPayerEmail: true
    });

    this.paymentRequest.on('paymentmethod', function (e) {
      form.email.value = e.paymentMethod.billing_details.email;

      stripe
        .confirmCardSetup(
          clientSecretValue,
          {
            payment_method: e.paymentMethod.id,
            return_url: returnUrl,
          })
        .then(function(result) {
          if (result.setupIntent) {
            form.payment_method.value = e.paymentMethod.card.wallet.type
            form.submit();
            e.complete('success');
          }
          if (result.error) {
            e.complete('fail');
          }
        })
      })
  }

  processPaymentRequest = async () => {
    try {
      const result = await this.paymentRequest.canMakePayment();
      var provider = this.setWalletProvider(result);
      this.setWalletVisibility(provider);
    } catch (error) {
      var provider = '';
    }
    const wallet = new CustomEvent("wallet", { detail: { name: provider } });
    window.dispatchEvent(wallet);
  }

  setWalletProvider(result) {
    if (result?.applePay) return 'apple';
    if (result?.googlePay) return 'google';
  }

  setWalletVisibility(provider) {
    if (['apple', 'google'].includes(provider)) {
      this.createPaymentRequestButton();
      this.prButton.mount('#payment-request-button');
    } else {
      document
        .getElementById('payment-request-button')
        .style
        .display = 'none';
    }
  }

  createPaymentRequestButton() {
    const elements = this.stripe.elements();
    const paymentRequest = this.paymentRequest;

    this.prButton = elements.create('paymentRequestButton', {
      paymentRequest
    });
  }

  setPricing(event) {
    this.amountValue = event.detail.due_at_pickup * 100; // Stripe expects the amount in cents

    this.paymentRequest.update({
      total: {
        label: this.labelValue,
        amount: this.amountValue
      }
    });
  }
}
